var transManager = {
	t : null,
	trans : null,
	dictKeyTrans : null,
	transIncDict : null,
	init : function() {

		//set t to the current locale
		var i = this;
		i.trans = {
			"en_GB" : {
				// "recent" : "Recent Posts",
				// "stats" : {
					// "replies" : "Replies",
					// "views" : "Views",
					// "kudos" : "Kudos"
				// },
				// "by" : "by",
				// "spoil" : "Contains Spoilers",
				// "img" : "Contains Image",
				// "get_p_id" : "Get your Portable ID here",
				// "country" : "United Kingdom",
				// "lang" : "English"
			},
			"en_AU" : {
				// "country" : "Australia",
				// "lang" : "English (ANZ)"
			},
			"en_US" : {
				// "country" : "USA"
			},
			"el_GR" : {
				/*"recent" : "Πρόσφατα Ποστ",
				"stats" : {
					"replies" : "Απαντήσεις",
					"views" : "Εμφανίσεις",
					"kudos" : "Kudos"
				},
				"by" : "από",
				"spoil" : "Περιέχει Spoilers",
				"img" : "Περιέχει Εικόνες",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Ελλάδα",
				"lang" : "ελληνικά"*/
			},
			"es_ES" : {
				/*"recent" : "Mensajes publicados recientes",
				"stats" : {
					"replies" : "Respuestas",
					"views" : "Visitas",
					"kudos" : "Kudos"
				},
				"by" : "por",
				"spoil" : "contiene spoilers",
				"img" : "contiene imagen",
				"get_p_id" : "Get your Portable ID here",
				"country" : "España",
				"lang" : "Español"*/
			},
			"fr_FR" : {
				/*"recent" : "Messages récents",
				"stats" : {
					"replies" : "Réponses",
					"views" : "Visites",
					"kudos" : "Kudos"
				},
				"by" : "par",
				"spoil" : "Contient des spoilers",
				"img" : "Contient des images",
				"get_p_id" : "Get your Portable ID here",
				"country" : "France",
				"lang" : "Français"*/
			},
			"it_IT" : {
				/*"recent" : "Post recenti",
				"stats" : {
					"replies" : "Risposte",
					"views" : "Visualizzazioni",
					"kudos" : "Kudos"
				},
				"by" : "di",
				"spoil" : "Contiene spoiler",
				"img" : "Contiene immagini",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Italia",
				"lang" : "Italiano"*/
			},
			"de_DE" : {
				/*"recent" : "Letzte Beiträge",
				"stats" : {
					"replies" : "Antworten",
					"views" : "Anzeigen",
					"kudos" : "Kudos"
				},
				"by" : "von",
				"spoil" : "Beinhaltet Spoiler",
				"img" : "Beinhaltet Bilder",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Deutschland",
				"lang" : "Deutsch"*/
			},
			"nl_NL" : {
				/*"recent" : "Recente berichten",
				"stats" : {
					"replies" : "Reacties",
					"views" : "Weergaven",
					"kudos" : "Kudos"
				},
				"by" : "door",
				"spoil" : "Bevat spoilers",
				"img" : "Bevat afbeeldingen",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Nederland",
				"lang" : "Nederlands"*/
			},
			"pt_PT" : {
				/*"recent" : "Envios recentes",
				"stats" : {
					"replies" : "Respostas",
					"views" : "Apresentações",
					"kudos" : "Kudos"
				},
				"by" : "por",
				"spoil" : "Contém spoilers",
				"img" : "Contém imagens",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Portugal",
				"lang" : "Português"*/
			},
			"pl_PL" : {
				/*"recent" : "",
				"stats" : {
					"replies" : "Odpowiedzi",
					"views" : "Wyswietlenia",
					"kudos" : "Kudos"
				},
				"by" : "przez",
				"spoil" : "Contém spoilers",
				"img" : "Zawiera obrazy",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Polska",
				"lang" : "Polski"*/
			},
			"fi_FI" : {
				/*"recent" : "Uudet kirjoitukset",
				"stats" : {
					"replies" : "Vastauksia",
					"views" : "Näytöt",
					"kudos" : "Kehuja"
				},
				"by" : "kirjoittaja",
				"spoil" : "Sisältää paljastuksia",
				"img" : "Sisältää kuvia",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Suomi",
				"lang" : "Suomi"*/
			},
			"ru_RU" : {
				/*"recent" : "Последние сообщения",
				"stats" : {
					"replies" : "Ответы",
					"views" : "Просмотры",
					"kudos" : "Kudos"
				},
				"by" : "От",
				"spoil" : "Спойлеры",
				"img" : "Изображения",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Россия",
				"lang" : "Русский"*/
			},
			"sv_SE" : {
				/*"recent" : "Ostatnie Posts",
				"stats" : {
					"replies" : "Svar",
					"views" : "Visninger",
					"kudos" : "Kudos"
				},
				"by" : "av",
				"spoil" : "Innehåller spoilers",
				"img" : "Innehåller bilder",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Sverige",
				"lang" : "Svenska"*/
			},
			"no_NO" : {
				/*"recent" : "Siste meldinger",
				"stats" : {
					"replies" : "Svar",
					"views" : "Visninger",
					"kudos" : "Kudos"
				},
				"by" : "av",
				"spoil" : "Inneholder spoilers",
				"img" : "Inneholder bilder",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Norge",
				"lang" : "Skandinavisk"*/
			},
			"ar_AE" : {
				/*"recent" : "المشاركات الأخيرة",
				"stats" : {
					"replies" : "الردود",
					"views" : "المشاهدات",
					"kudos" : "نقاط الاعجاب"
				},
				"by" : "من قبل",
				"spoil" : "يحتوي على معلومات مفسدة للتجربة أو الرواية",
				"img" : "يحتوي على صور",
				"get_p_id" : "احصل على اسم مستخدم للاجهزة المحمولة هنا",
				"country" : "الامارات العربية المتحدة",
				"lang" : "اللغة العربية"*/
			},
			"da_DK" : {
				/*"recent" : "Seneste indlæg",
				"stats" : {
					"replies" : "Svar",
					"views" : "Visninger",
					"kudos" : "Kudos"
				},
				"by" : "af",
				"spoil" : "Indeholder spoilers",
				"img" : "Indeholder billeder",
				"get_p_id" : "Get your Portable ID here",
				"country" : "Danmark",
				"lang" : "Skandinavisk"*/
			},
			"ja_JP" : {
				/*"recent" : "Recent Posts",
				"stats" : {
					"replies" : "Replies",
					"views" : "Views",
					"kudos" : "Kudos"
				},
				"by" : "by",
				"spoil" : "Contains Spoilers",
				"img" : "Contains Image",
				"get_p_id" : "Get your Portable ID here",
				"country" : "United Kingdom",
				"lang" : "日本語"*/
			},
			"tr_TR" : {
				/*"recent" : " Son İletiler",
				"stats" : {
					"replies" : "Cevaplar",
					"views" : "Görüntülenme",
					"kudos" : "Beğen"
				},
				"by" : "tarafından",
				"spoil" : "Spoiler içeriyor",
				"img" : "Görsel içeriyor",
				"get_p_id" : "Taşınabilir ID'nizi buradan edinin",
				"country" : "Türkiye",
				"lang" : "Türkçe"*/
			}


		};
		i.t = i.trans[eM.cP.localeKey];

	},
	getTrans : function() {
		var i = this;

		if (i.t == null) {
			i.init();
		}
		return i.t;
	},
	getTransIncDict : function() {
		var i = this;
		if (i.transIncDict == null) {
			i.transIncDict = {};
			i.getTrans();
			var dictKeys = i.getTransFromHiddenDict();
			for (var k in i.t) {
				i.transIncDict[k] = i.t[k];
			}
			for (var k in dictKeys) {
				i.transIncDict[k] = dictKeys[k];
			}
		}
		return i.transIncDict;

	},
	getAllTrans : function() {
		var i = this;

		if (i.trans == null) {
			i.init();
		}
		return i.trans;

	},
	getTransFromHiddenDict : function() {
		var i = this;
		if (i.dictKeyTrans == null) {
			i.dictKeyTrans = {};
			//we see if the page has a hidden dictionary of translations
			$("#sonyDict").find('li').each(function() {
				var cur = $(this);
				i.dictKeyTrans[cur.attr('id')] = cur.html();
			});
			//if so, we access it, looping through, using the id as a key
		}
		return i.dictKeyTrans;

	}
}; 